class Drawer extends HTMLElement {
    constructor() {
        super()
        this.sectionId = this.dataset.sectionId

        this.config = {
            trigger_selectors: this.dataset.triggers?.trim().split(" ") ?? [
                `${this.tagName}-trigger`,
            ],
        }
    }

    connectedCallback() {
        this.registerTriggers()
    }

    registerTriggers() {
        var drawer = this
        this.triggers = this.config.trigger_selectors
            .map((trigger_sel) =>
                Array.from(document.querySelectorAll(trigger_sel))
            )
            .flat()

        this.triggers.forEach((trigger) => {
            trigger.addEventListener("click", (e) => {
                e.preventDefault()
                e.stopPropagation()
                drawer.isOpen.call(drawer)
                    ? drawer.close.call(drawer)
                    : drawer.open.call(drawer)
            })
        })

        this.querySelectorAll(".close-popup").forEach((button) => {
            button.addEventListener("click", (e) => {
                e.preventDefault()
                e.stopPropagation()
                this.close()
            })
        })
    }

    afterOpenCallback() {}

    afterCloseCallback() {}

    async open() {
        return new Promise((res, rej) => {
            this.triggers.forEach((trigger) =>
                trigger.classList.add(`${this.tagName.toLowerCase()}-open`)
            )
            setTimeout(() => {
                this.classList.add("open")
                document.body.classList.add("!overflow-hidden")
                document.body.classList.add("!max-h-screen")
            }, 50)
            res(0)
        }).then(() => {
            this.afterOpenCallback()
        })
    }

    async close() {
        return new Promise((res, rej) => {
            this.triggers.forEach((trigger) =>
                trigger.classList.remove(`${this.tagName.toLowerCase()}-open`)
            )
            this.classList.remove("open")
            document.body.classList.remove("!overflow-hidden")
            document.body.classList.remove("!max-h-screen")
            res(0)
        }).then((val) => {
            this.afterCloseCallback()
        })
    }

    isOpen() {
        return this.classList.contains("open")
    }
}

class ProductPopup extends Drawer {
    constructor() {
        super()
        this.config.addonTrigger = `[data-addon-trigger]`
        this.popupContent = null
    }

    connectedCallback() {
        super.connectedCallback()

        document
            .querySelectorAll(this.config.addonTrigger)
            .forEach((trigger) => {
                trigger.addEventListener("click", (e) => {
                    e.preventDefault()
                    this.dataset.activeAddon = trigger.dataset.addonTrigger
                    this.popupContent = document.getElementById(this.dataset.activeAddon)
                })
            })

        document.addEventListener('click', this.handleClickOutside.bind(this))
        this.addEventListener('click', this.handleAddToCart.bind(this))
    }

    handleClickOutside(event) {
        if (this.isOpen() && this.popupContent && !this.popupContent.contains(event.target)) {
            this.close()
        }
    }

    handleAddToCart(event) {
        const addToCartButton = event.target.closest('[type="addToCart"]');
        if (addToCartButton) {
            document.querySelectorAll('product-popup').forEach(popup => {
                if (popup.isOpen()) {
                    popup.close()
                }
            });
        }
    }

    afterOpenCallback() {}

    afterCloseCallback() {}
}

customElements.define("product-popup", ProductPopup)

class PriceDiscount extends HTMLElement {
    constructor() {
      super();
      this.priceElement = this.querySelector('price-quote');
      this.discountElement = this.querySelector('[data-discount-element]');
      this.originalPriceElement = this.querySelector('[data-original-price-element]');
      this.originalPrice = parseFloat(this.getAttribute('data-original-price'));
      this.discountPercent = parseFloat(this.getAttribute('data-discount-percent'));
    }
  
    connectedCallback() {
      this.updateDiscountedPrice();

      const observer = new MutationObserver(() => {
        this.updateDiscountedPrice();
      });
  
      observer.observe(this.priceElement, { attributes: true });
    }
  
    updateDiscountedPrice() {
      const price = parseFloat(this.priceElement.getAttribute('data-price'));
      const discountedPrice = (price/100) * (1 - this.discountPercent / 100);
      const roundedPrice = Math.round(discountedPrice);
      this.discountElement.textContent = `$${roundedPrice}`;

      const roundedOriginalPrice = Math.round(price / 100);
      this.originalPriceElement.textContent = `$${roundedOriginalPrice}`;
    }
}

customElements.define('price-discount', PriceDiscount);
  